import type { JSX } from 'preact';
import styles from './PromotionLineItem.module.scss';

function GiftingIcon(): JSX.Element {
  return <span class={styles.giftingIcon} />;
}

export { GiftingIcon };
